import styled from 'styled-components';
import Name from 'gatsby-theme-employees/src/components/preview/name';

export default styled(Name)`
  font-size: 1.125rem;
`;
